import { Link } from "react-router-dom";
import { HeroLines, Reveal } from "../components/Reveal";
import { PHONE_DISPLAY, PHONE_LINK, HOURS } from "../data/content";

const SECTIONS = [
  {
    num: "01",
    title: "Éditeur du site",
    content: (
      <>
        <p>
          <strong>Quercy Nuisibles</strong> — Entreprise de lutte contre les
          nuisibles, basée à Cahors, Lot (46).
        </p>
        <p className="mt-3">
          Téléphone :{" "}
          <a href={PHONE_LINK} className="font-semibold text-[#E50914] hover:underline">
            {PHONE_DISPLAY}
          </a>
          <br />
          Horaires : {HOURS}
        </p>
        <p className="mt-3">
          Directeur de la publication : Jean-Philippe CUSTODIO.
          <br />
          Forme juridique et numéro SIRET : Entreprise Individuelle, 512 772 674 00036.
        </p>
      </>
    ),
  },
  {
    num: "02",
    title: "Conception & Hébergement",
    content: (
      <p>
        Ce site est propulsé par{" "}
        <a
          href="https://equinoxe.studio"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#E50914] hover:underline"
        >
          Equinoxe Studio
        </a>
        .
      </p>
    ),
  },
  {
    num: "03",
    title: "Propriété intellectuelle",
    content: (
      <>
        <p>
          Le logo, les textes, la charte graphique et les photographies du
          véhicule et des interventions sont la propriété exclusive de Quercy
          Nuisibles. Toute reproduction ou utilisation sans autorisation
          préalable est interdite.
        </p>
        <p className="mt-3">
          Les photographies d'illustration des nuisibles proviennent des
          banques d'images libres de droits Pexels et Unsplash.
        </p>
      </>
    ),
  },
  {
    num: "04",
    title: "Données personnelles (RGPD)",
    content: (
      <>
        <p>
          Le formulaire de contact collecte votre nom, votre adresse email,
          votre numéro de téléphone et votre message. Ces données sont
          utilisées exclusivement pour répondre à votre demande de devis et
          planifier une intervention.
        </p>
        <p className="mt-3">
          Elles ne sont ni vendues, ni cédées à des tiers, et sont conservées
          au maximum 12 mois. Conformément au RGPD, vous disposez d'un droit
          d'accès, de rectification et de suppression de vos données : il
          suffit de nous contacter au {PHONE_DISPLAY} ou via le{" "}
          <Link to="/contact" className="font-semibold text-[#E50914] hover:underline">
            formulaire de contact
          </Link>
          .
        </p>
      </>
    ),
  },
  {
    num: "05",
    title: "Cookies",
    content: (
      <p>
        Ce site n'utilise aucun cookie publicitaire. Une mesure d'audience
        technique peut être utilisée pour améliorer le site ; elle ne permet
        pas de vous identifier personnellement.
      </p>
    ),
  },
];

export default function MentionsLegales() {
  return (
    <main>
      <section data-testid="legal-header" className="hexa-bg overflow-hidden border-b border-black">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8 pt-32 md:pt-40 pb-16 md:pb-20">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#E50914]">
            [ Informations légales ]
          </p>
          <HeroLines
            className="font-display uppercase leading-[0.9] tracking-tight text-[12vw] md:text-[6.5rem] mt-6"
            lines={[{ text: "Mentions légales" }]}
          />
          <Reveal delay={0.3}>
            <p className="mt-8 max-w-2xl text-base md:text-lg text-neutral-600">
              Éditeur, hébergement, propriété intellectuelle et protection de
              vos données personnelles.
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="legal-content">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8">
          {SECTIONS.map((section) => (
            <Reveal key={section.num}>
              <article
                data-testid={`legal-section-${section.num}`}
                className="grid gap-4 md:grid-cols-12 border-b border-black py-12 md:py-16"
              >
                <div className="md:col-span-4 flex items-start gap-4">
                  <span className="font-display text-2xl text-neutral-300">
                    {section.num}
                  </span>
                  <h2 className="font-display uppercase text-2xl md:text-3xl tracking-tight">
                    {section.title}
                  </h2>
                </div>
                <div className="md:col-span-8 text-base text-neutral-600 leading-relaxed">
                  {section.content}
                </div>
              </article>
            </Reveal>
          ))}
          <p className="py-10 text-xs text-neutral-400">
            Dernière mise à jour : septembre 2026.
          </p>
        </div>
      </section>
    </main>
  );
}
